import { Clickable, Collapse, Hidden, Span } from '@ahmdigital/ui';
import { ReactNode, useState } from 'react';
import classNames from 'classnames';
import styled from 'styled-components';

import styles from './styles.module.sass';

const Transition = styled.div<{ isOpen: boolean }>`
  opacity: 1;
  transition: opacity 0.25s;
  transition-delay: 0.25s;

  ${({ isOpen }) =>
    isOpen
      ? ''
      : `
    opacity: 0;
    transition:none;
  `}
`;

const Flex = styled.div`
  display: flex;
  flex-direction: column;
`;

type TitledCollapseProps = {
  body: ReactNode;
  id: string;
  title: string;
};

const TitledCollapse = ({ body, id, title }: TitledCollapseProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const ariaControls = `trigger-${id}`;
  const titleComponent = (
    <Span variant="bold" className={styles.headerText}>
      {title}
    </Span>
  );

  return (
    <div className={styles.wrapper}>
      <Hidden md lg df>
        <div className={styles.header}>{titleComponent}</div>
        {body}
      </Hidden>
      <Hidden xs sm>
        <Flex>
          <Clickable aria-expanded={isOpen} aria-controls={ariaControls} isUnstyled onClick={() => setIsOpen(!isOpen)}>
            <div className={styles.header}>
              <div
                className={classNames(styles.caret, {
                  // @ts-expect-error - Automatic, Please fix when editing this file
                  [styles.isCaretClosed]: !isOpen,
                })}
              />
              {titleComponent}
            </div>
          </Clickable>
          <Collapse ariaControls={ariaControls} isOpen={isOpen}>
            <Transition isOpen={isOpen}>{body}</Transition>
          </Collapse>
        </Flex>
      </Hidden>
    </div>
  );
};

export default TitledCollapse;
